import mixpanel from 'mixpanel-browser';

import { FilterInteractionTrackingEvents } from '@revelio/core';

export type EntityInfoAction =
  | 'opened'
  | 'parent_offered'
  | 'competitors_expanded';

/**
 * `entity info interaction`: the company info tooltip in a tree. The tree is
 * shared across surfaces with and without a page context, so the route is
 * stamped here rather than read from one.
 */
export const trackEntityInfoInteraction = (
  action: EntityInfoAction,
  props: { can_add?: boolean; competitor_count?: number } = {}
) => {
  mixpanel.track(FilterInteractionTrackingEvents.ENTITY_INFO_INTERACTION, {
    action,
    page_path: window.location.pathname,
    ...props,
  });
};
